/* eslint-disable react/prop-types */
import Divider from "@mui/material/Divider";
import * as React from "react";

export default function GeneralInfo({singleGhollak}) {
  return (
    <>      <p>نام سازنده: {`${singleGhollak?.creator?.first_name} ${singleGhollak?.creator?.last_name}`}</p>
      <p>شماره تماس سازنده: {singleGhollak?.creator?.phone_number}</p>
      <p>کد ملی سازنده: {singleGhollak?.creator?.national_code}</p>
      <p>ایمیل سازنده: {singleGhollak?.creator?.email}</p>
      {singleGhollak?.creator_id !== singleGhollak?.user_id && <>
        <Divider />
        <p>نام مالک: {`${singleGhollak?.user?.first_name} ${singleGhollak?.user?.last_name}`}</p>
        <p>شماره تماس مالک: {singleGhollak?.user?.phone_number}</p>
        <p>کد ملی مالک: {singleGhollak?.user?.national_code}</p>
        <p>ایمیل مالک: {singleGhollak?.user?.email}</p>
      </>}
    </>
  );
}
